var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoadingState < 4)?_c('div',{key:"loadingState",staticClass:"o-edition-section-chart"},[_c('AtomLoadingPrimary')],1):_c('div',{key:"sectionChart",staticClass:"o-edition-section-chart"},[_c('MoleculeEditionMapChart',{attrs:{"element":_vm.element}}),_c('MoleculeEditionSectionChartFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }